<template>
  <JoszakiModal
    :open="authDialogOpen"
    icon="bookmark"
    :title="$t('favourites.authDialog.title')"
    :subtitle="$t('favourites.authDialog.subtitle')"
    size="md"
    hide-header
    hide-footer
    @close="closeAuthDialog"
    @cancel="closeAuthDialog"
  >
    <template #body>
      <!-- Header -->
      <div class="flex flex-row items-center gap-2">
        <JoszakiButton
          v-for="tab in tabs"
          :key="tab.key"
          :type="activeTab === tab.key ? 'info' : 'default'"
          :inverted="activeTab !== tab.key"
          :outline="activeTab !== tab.key"
          expanded
          @click="activeTab = tab.key"
        >
          {{ tab.label }}
        </JoszakiButton>
      </div>

      <div>
        <LoginForm
          v-if="activeTab === 'login'"
          :has-registration-link="false"
          :navigate-on-success="false"
          @success="onAuthSuccess"
        />
        <CustomerRegistrationForm
          v-else
          :has-login-link="false"
          :navigate-on-success="false"
          @success="onAuthSuccess"
        />

        <p class="mt-2 text-center text-sm text-gray-500 dark:text-gray-300">
          <template v-if="activeTab === 'login'">
            {{ $t("favourites.authDialog.noAccountYet") }}
            <button
              class="font-semibold text-primary hover:underline"
              @click="activeTab = 'register'"
            >
              {{ $t("favourites.authDialog.registerLink") }}
            </button>
          </template>
          <template v-else>
            {{ $t("favourites.authDialog.haveAccount") }}
            <button
              class="font-semibold text-primary hover:underline"
              @click="activeTab = 'login'"
            >
              {{ $t("favourites.authDialog.loginLink") }}
            </button>
          </template>
        </p>
      </div>
    </template>
  </JoszakiModal>
</template>

<script>
import { computed, ref, useContext, watch } from "@nuxtjs/composition-api";
import { useFavourites } from "~/composables/favourite/useFavourites";
import JoszakiModal from "~/components/_refactored/common/JoszakiModal.vue";
import LoginForm from "~/components/_refactored/login/LoginForm.vue";
import CustomerRegistrationForm from "~/components/_refactored/customer-registration/CustomerRegistrationForm.vue";

export default {
  name: "FavouriteAuthDialog",
  components: { JoszakiModal, LoginForm, CustomerRegistrationForm },
  setup() {
    const { i18n } = useContext();
    const { authDialogOpen, closeAuthDialog, applyPendingFavourite } =
      useFavourites();

    const activeTab = ref("login");

    // Always reopen on the Login tab — this dialog is a persistent singleton.
    watch(authDialogOpen, (open) => {
      if (open) {
        activeTab.value = "login";
      }
    });

    const tabs = computed(() => [
      { key: "login", label: i18n.t("favourites.authDialog.loginTab") },
      { key: "register", label: i18n.t("favourites.authDialog.registerTab") },
    ]);

    async function onAuthSuccess() {
      await applyPendingFavourite();
    }

    return {
      authDialogOpen,
      closeAuthDialog,
      onAuthSuccess,
      activeTab,
      tabs,
    };
  },
};
</script>
